import { SAL2050_R01TabType } from '../Store_SAL2050_R01';

export const SAL2050_R01_TABS = [
	{ id: 'customer' as const, label: '거래처별' },
	{ id: 'item' as const, label: '품목별' },
];

const VIEW_TYPE_BY_TAB: Record<SAL2050_R01TabType, string> = {
	customer: 'customer',
	item: 'item',
};

const DISPLAY_NAME_BY_TAB: Record<SAL2050_R01TabType, string> = {
	customer: '거래처별',
	item: '품목별',
};

export const getViewType = (tab: SAL2050_R01TabType): string => {
	return VIEW_TYPE_BY_TAB[tab] ?? VIEW_TYPE_BY_TAB.customer;
};

export const getTabDisplayName = (tab: SAL2050_R01TabType): string => {
	return DISPLAY_NAME_BY_TAB[tab] ?? DISPLAY_NAME_BY_TAB.customer;
};

export const getSubtotalRowId = (tabType: SAL2050_R01TabType, groupKey: string): string => {
	return `subtotal-${tabType}-${groupKey}`;
};

export const getDetailRowId = (tabType: SAL2050_R01TabType, row: any): string => {
	switch (tabType) {
		case 'customer':
			return `${row?.compCd}-${row?.customCd}`;
		case 'item':
			return `${row?.compCd}-${row?.itemCd}`;
		default:
			return row?.id ?? '';
	}
};

export const dedupeRowsByTab = <T extends Record<string, any>>(tabType: SAL2050_R01TabType, rows: T[]): T[] => {
	const seen = new Set<string>();
	const uniqueRows: T[] = [];

	for (const row of rows) {
		const rowId = getDetailRowId(tabType, row);
		if (!rowId || seen.has(rowId)) continue;
		seen.add(rowId);
		uniqueRows.push(row);
	}

	return uniqueRows;
};
